import { FC } from 'react';
import { ActionModal, ElementsForm, ModalActionProps, PersonalPropertyItemEstimatedValueInput } from '../../UI';
import { useTranslation } from 'react-i18next';
import { PersonalPropertyItem } from '../../generated/graphql';
import { getPersonalPropertyItemValue, getUpdatePersonalPropertyItemServiceInputFromForm } from '../util';
import { useUpdatePersonalPropertyItemValueService } from '../service';
import { useEditPersonalPropertyItemForm } from '../../UI';

export type EditPersonalPropertyItemBalanceModalProps = Pick<ModalActionProps, 'onCancel' | 'isLoading' | 'onSave'> & {
  personalPropertyItem: PersonalPropertyItem;
  afterUpdate?: (personalPropertyItem: PersonalPropertyItem) => Promise<void>;
};

export const EditPersonalPropertyItemBalanceModal: FC<EditPersonalPropertyItemBalanceModalProps> = ({
  onSave,
  isLoading,
  onCancel,
  personalPropertyItem,
  afterUpdate,
}) => {
  const { t: tCommon } = useTranslation('common');
  const { updatePersonalPropertyItemValueService } = useUpdatePersonalPropertyItemValueService();

  const formReturn = useEditPersonalPropertyItemForm({
    defaultValues: { estimatedValue: getPersonalPropertyItemValue(personalPropertyItem)?.value / 100 || 0 },
    handleSubmit: async ({ formValues }) => {
      await updatePersonalPropertyItemValueService.mutateAsync(
        getUpdatePersonalPropertyItemServiceInputFromForm({
          formValues,
          householdID: personalPropertyItem.householdID,
          personalPropertyItemID: personalPropertyItem.id,
          changeToken: personalPropertyItem.changeToken,
          valueDataPointGroupID: personalPropertyItem.value.id,
        })
      );
      await afterUpdate?.(personalPropertyItem);
    },
    saveOnChange: false,
  });
  return (
    <ActionModal title={personalPropertyItem.name} subtitle={tCommon('personal-property-item')}>
      {(action) => (
        <ElementsForm useFormReturn={formReturn}>
          <PersonalPropertyItemEstimatedValueInput />
          {action({
            onSave,
            isLoading: isLoading || updatePersonalPropertyItemValueService.isLoading,
            onCancel,
          })}
        </ElementsForm>
      )}
    </ActionModal>
  );
};
